var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
export var List = function (_a) {
    var items = _a.items, renderItem = _a.renderItem, children = _a.children, props = __rest(_a, ["items", "renderItem", "children"]);
    return (React.createElement("div", __assign({}, props),
        (items || []).map(renderItem),
        children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/list/List.tsx
// module id = 59
// module chunks = 3